const DROPDOWN_SELECTOR = '.picky-option__dropdown';
const OPEN_CLASS = 'amplify-bundle-breaks-widget__dropdown--open';
const ITEM_OPEN_CLASS = 'amplify-bundle-breaks-widget__item--dropdown-open';
const ENHANCED_ATTR = 'data-amplify-custom-select';
const ITEM_SELECTOR = '.picky-bundle-breaks__item';
const BADGE_SELECTOR = '.picky-bundle-breaks__badge';
const PRICE_SELECTOR = '.picky-qb-offer-item__price';
const COMPARE_SELECTOR = '.picky-qb-offer-item__compare-at-price';
const SELECTED_ITEM_SELECTOR = `${ITEM_SELECTOR}[class*="_collapsableGroup_selected_"]`;
const TIER_NAME_SELECTOR = '.picky-qb-offer-item__title';
const STICKY_PRICE_SELECTOR = '.sticky-quick-add .sticky-regular-price .price';
const STICKY_BTN_PRICE_SELECTOR =
  '.sticky-quick-add #btn-add .equipment.price, .picky-theme-atc-wrapper #btn-add .equipment.price';
const STICKY_TITLE_SELECTOR = '.sticky-quick-add .product-info__value';
const STICKY_VARIANT_INFO_SELECTOR =
  '.sticky-quick-add .color-info, .sticky-quick-add .size-info';
const SIZE_OPTION_SELECTOR = '.picky-option[data-option-name="Size"]';
const PDP_COLOR_SWATCH_SELECTOR =
  '.product__info-wrapper .product-alt-colours a.color_swatch_item';
const PDP_SIZE_INPUT_SELECTOR =
  'variant-radios .size_option_input .size_slider .item input';
const FIRST_CARD_SIZE_SELECT_SELECTOR = `${ITEM_SELECTOR} .picky-product-card:first-of-type ${SIZE_OPTION_SELECTOR} select`;
const SIZE_SLIDER_INPUT_SELECTOR =
  '.size_option_input .size_slider input[type="radio"]';
const ATC_BUTTON_SELECTOR = '[data-amplify-bundle-atc-button]';
const ATC_FALLBACK_DELAY = 3000;
const VARIANT_SYNC_DELAYS = [500, 1100];
const MOBILE_MEDIA = '(max-width: 1023px)';
const STICKY_BAR_SELECTOR = '.sticky-quick-add';
const STICKY_PRICE_HIDDEN_CLASS = 'amplify-bundle-sticky-price-hidden';
const INACTIVE_OPTION_CLASS = 'amplify-bundle-breaks-widget__option--inactive';
const PRODUCT_OPTION_SELECTOR = '.picky-product-card .picky-option';
const FIRST_CARD_SELECTOR = `${ITEM_SELECTOR} .picky-product-card:first-of-type`;
const PRODUCT_CARD_SELECTOR = '.picky-product-card';
const BUNDLE_CONTENT_SELECTOR = '.picky-bnd-pdp';
const PRODUCT_CARD_UNAVAILABLE_CLASS_PATTERN = /_notAvailable_|_isDeactivated_/;
const TIER_UNAVAILABLE_CLASS =
  'amplify-bundle-breaks-widget__item--unavailable';
const WIDGET_EMPTY_CLASS = 'amplify-bundle-breaks-widget--empty';
const WIDGET_VARIANT_OOS_CLASS = 'amplify-bundle-breaks-widget--variant-oos';
const NOTIFY_BUTTON_SELECTOR = '[data-test="notifyTriggerBtn"]';
const SELECTED_VARIANT_INPUT_SELECTOR =
  'input[data-variant-id][data-available]:checked';
const STICKY_ATC_BUTTON_SELECTOR = '#btn-add';
const PRODUCT_FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';
const PRODUCT_INFO_CONTAINER_SELECTOR = '.product__info-container';
const ATC_BLOCKED_CLASS = 'amplify-bundle-breaks-atc-blocked';
const OUT_OF_STOCK_SELECTOR = '[class*="_outOfStock_"]';
const TIER_SELECTED_CLASS_PATTERN = /_collapsableGroup_selected_/;
const GB_CLASS_VARIATION_TESTS = [
  {
    suffix: 'upsell_bundle',
    viewParam: 'upsell_bundle',
    classB: 'ab-apparel-bundles-b'
  },
  {
    suffix: 'upsell_bundle_equip',
    viewParam: 'upsell_bundle_equip',
    classB: 'ab-bundles-equip-v2-b'
  },
  {
    suffix: 'equipment_amplify',
    viewParam: 'equipment_amplify',
    classB: 'ab-bundles-equip-v2-b'
  }
];

const getActiveGbClassVariationTests = () => {
  const tmpl = document.body?.dataset?.template || '';
  const viewParam = new URL(location.href).searchParams.get('view');

  return GB_CLASS_VARIATION_TESTS.filter(
    test => tmpl === `product.${test.suffix}` || viewParam === test.viewParam
  );
};

const isAnyGbVariationBActive = tests =>
  tests.some(test => document.documentElement.classList.contains(test.classB));

const isMobileViewport = () => window.matchMedia(MOBILE_MEDIA).matches;

const setRadioChecked = (input, checked) => {
  const setter = Object.getOwnPropertyDescriptor(
    HTMLInputElement.prototype,
    'checked'
  )?.set;

  if (setter) {
    setter.call(input, checked);
  } else {
    input.checked = checked;
  }
};

const parsePrice = text => {
  const cleaned = (text || '').replace(/[^0-9.,]/g, '');
  if (!cleaned) return NaN;

  const lastSep = Math.max(cleaned.lastIndexOf(','), cleaned.lastIndexOf('.'));
  if (lastSep === -1) return parseFloat(cleaned);

  const integerPart = cleaned.slice(0, lastSep).replace(/[.,]/g, '');
  return parseFloat(`${integerPart}.${cleaned.slice(lastSep + 1)}`);
};

const applyPriceBlock = (priceBlock, finalText, compareText) => {
  if (!priceBlock) return;

  const saleItem = priceBlock.querySelector('.price-item--sale');
  if (!saleItem) return;

  const hasCompare = Boolean(compareText);
  if (saleItem.textContent.trim() !== finalText)
    saleItem.textContent = finalText;
  saleItem.classList.toggle('sale-red', hasCompare);
  priceBlock.classList.toggle('price--on-sale', hasCompare);

  let compareDd = priceBlock.querySelector('dd.price__compare');
  if (hasCompare) {
    if (!compareDd) {
      compareDd = document.createElement('dd');
      compareDd.className = 'price__compare';
      compareDd.innerHTML =
        '<span class="price-item price-item--regular"></span>';
      saleItem.closest('dd')?.after(compareDd);
    }
    compareDd.style.removeProperty('display');
    const regular = compareDd.querySelector('.price-item--regular');
    if (regular && regular.textContent.trim() !== compareText) {
      regular.textContent = compareText;
    }
  } else if (compareDd) {
    compareDd.style.display = 'none';
  }
};

const applyStickyButton = (finalText, compareText) => {
  const btnPrice = document.querySelector(STICKY_BTN_PRICE_SELECTOR);
  if (!btnPrice) return;

  const compareHtml = compareText
    ? ` <span style="font-weight: 500;" class="price-old-btn"><span>/</span> <span class="old-switch-price" style="text-decoration: line-through;">${compareText}</span></span>`
    : '';
  const nextHtml = `- ${finalText}${compareHtml}`;

  if (btnPrice.innerHTML !== nextHtml) btnPrice.innerHTML = nextHtml;
};

class AmplifyBundleBreaksWidget extends HTMLElement {
  static _atcBound = false;
  static _bundleAddInFlight = false;
  static _bundleAddTimer = null;

  constructor() {
    super();
    this._prevOptionBySelect = new WeakMap();
    this._pdpPreviousSize = null;
    this._pendingTierItem = null;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this._onDocumentPointerDown = this._handleDocumentPointerDown.bind(this);
    this._onFormChange = this._handleFormChange.bind(this);
    this._onSizeSliderChange = this._handleSizeSliderChange.bind(this);
    this._onWidgetMutations = this._handleWidgetMutations.bind(this);
    this._onAtcClickCapture = this._handleAtcClickCapture.bind(this);
    this._onFormSubmitCapture = this._handleFormSubmitCapture.bind(this);
    this._onTierPointerDown = this._handleTierPointerDown.bind(this);
    this._onWidgetOptionChange = this._handleWidgetOptionChange.bind(this);
    this._onAtcAnalytics = this._handleAtcAnalytics.bind(this);
    this._onPdpColorClick = this._handlePdpColorClick.bind(this);
    this._onPdpSizePointerDown = this._handlePdpSizePointerDown.bind(this);
    this._onPdpSizeChange = this._handlePdpSizeChange.bind(this);
    this._onSizeMemoryApplied = this._handleSizeMemoryApplied.bind(this);
    this._onDomContentLoaded = this._handleDomContentLoaded.bind(this);

    document.addEventListener('click', this._onAtcClickCapture, true);
    document.addEventListener('submit', this._onFormSubmitCapture, true);
    document.addEventListener('click', this._onAtcAnalytics, true);
    document.addEventListener('pointerdown', this._onTierPointerDown, true);
    document.addEventListener('pointerdown', this._onDocumentPointerDown);
    document.addEventListener('change', this._onFormChange);
    document.addEventListener('change', this._onSizeSliderChange);
    document.addEventListener('change', this._onWidgetOptionChange);
    document.addEventListener('click', this._onPdpColorClick);
    document.addEventListener('pointerdown', this._onPdpSizePointerDown, true);
    document.addEventListener('change', this._onPdpSizeChange);
    document.addEventListener('size-memory:applied', this._onSizeMemoryApplied);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this._onDomContentLoaded);
    } else {
      this._runSizeSync();
    }

    this._observer = new MutationObserver(this._onWidgetMutations);
    this._observer.observe(this, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
      attributeOldValue: true
    });

    AmplifyBundleBreaksWidget._bindAtcGuard();
    this._bundleBlockSeen = false;
    this._onResize = this._handleResize.bind(this);
    window.addEventListener('resize', this._onResize);
    this._bindBundleVisibility();
    this._bindAtcButtonGuard();
    this._bindVariationObserver();
    this._enhance();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onAtcClickCapture, true);
    document.removeEventListener('submit', this._onFormSubmitCapture, true);
    document.removeEventListener('click', this._onAtcAnalytics, true);
    document.removeEventListener('pointerdown', this._onTierPointerDown, true);
    document.removeEventListener('pointerdown', this._onDocumentPointerDown);
    document.removeEventListener('change', this._onFormChange);
    document.removeEventListener('change', this._onSizeSliderChange);
    document.removeEventListener('change', this._onWidgetOptionChange);
    document.removeEventListener('click', this._onPdpColorClick);
    document.removeEventListener(
      'pointerdown',
      this._onPdpSizePointerDown,
      true
    );
    document.removeEventListener('change', this._onPdpSizeChange);
    document.removeEventListener(
      'size-memory:applied',
      this._onSizeMemoryApplied
    );
    document.removeEventListener('DOMContentLoaded', this._onDomContentLoaded);
    window.removeEventListener('resize', this._onResize);
    this._visibilityObserver?.disconnect();
    this._atcButtonObserver?.disconnect();
    this._variationObserver?.disconnect();
    this._observer?.disconnect();
    document
      .querySelector(STICKY_BAR_SELECTOR)
      ?.classList.remove(STICKY_PRICE_HIDDEN_CLASS);
    this._initialized = false;
  }

  static _bindAtcGuard() {
    if (AmplifyBundleBreaksWidget._atcBound) return;
    AmplifyBundleBreaksWidget._atcBound = true;

    const endBundleAdd = AmplifyBundleBreaksWidget._endBundleAdd;
    const toggleAtcLoading = AmplifyBundleBreaksWidget._toggleAtcLoading;

    document.addEventListener(
      'click',
      event => {
        const button = event.target.closest(ATC_BUTTON_SELECTOR);
        if (!button) return;
        if (!AmplifyBundleBreaksWidget._isWidgetActive()) return;

        const widget = document.querySelector('amplify-bundle-breaks-widget');
        if (!widget?.querySelector(SELECTED_ITEM_SELECTOR)) return;

        if (AmplifyBundleBreaksWidget._bundleAddInFlight) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        AmplifyBundleBreaksWidget._bundleAddInFlight = true;
        toggleAtcLoading(true);
        AmplifyBundleBreaksWidget._bundleAddTimer = window.setTimeout(
          endBundleAdd,
          ATC_FALLBACK_DELAY
        );
      },
      true
    );

    ['cart:added', 'cart:refresh', 'cart:updated'].forEach(eventName =>
      document.addEventListener(eventName, endBundleAdd)
    );

    new MutationObserver(() => {
      if (document.body.classList.contains('slide-cart')) endBundleAdd();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  static _toggleAtcLoading(isLoading) {
    document.querySelectorAll(ATC_BUTTON_SELECTOR).forEach(button => {
      button.classList.toggle('loading', isLoading);
      button
        .querySelector('.loading-overlay__spinner')
        ?.classList.toggle('hidden', !isLoading);
    });
  }

  static _endBundleAdd() {
    if (!AmplifyBundleBreaksWidget._bundleAddInFlight) return;
    AmplifyBundleBreaksWidget._bundleAddInFlight = false;
    if (AmplifyBundleBreaksWidget._bundleAddTimer) {
      clearTimeout(AmplifyBundleBreaksWidget._bundleAddTimer);
      AmplifyBundleBreaksWidget._bundleAddTimer = null;
    }
    AmplifyBundleBreaksWidget._toggleAtcLoading(false);
  }

  static _isWidgetActive() {
    const tests = getActiveGbClassVariationTests();
    if (!tests.length || !isAnyGbVariationBActive(tests)) {
      return false;
    }

    const widget = document.querySelector('amplify-bundle-breaks-widget');
    if (!widget) return false;

    return (
      !widget.classList.contains(WIDGET_EMPTY_CLASS) &&
      !widget.classList.contains(WIDGET_VARIANT_OOS_CLASS) &&
      getComputedStyle(widget).display !== 'none'
    );
  }

  static _shouldUseStandardPdpAtc() {
    const tests = getActiveGbClassVariationTests();
    return tests.length > 0 && !isAnyGbVariationBActive(tests);
  }

  _isWidgetActive() {
    if (!this._isPrimaryWidget()) return false;

    return AmplifyBundleBreaksWidget._isWidgetActive();
  }

  _isAnalyticsActive() {
    return this._isPrimaryWidget() && this._isWidgetActive();
  }

  _isPrimaryWidget() {
    return this === document.querySelector('amplify-bundle-breaks-widget');
  }

  _runSizeSync() {
    if (!this._isPrimaryWidget() || !this._isWidgetActive()) return;

    const sync = () => {
      this._syncSizeSliderToPicky();
      this._syncFirstCardAvailability();
      this._syncUnavailableTiers();
      this._syncAtcState();
    };

    sync();
    requestAnimationFrame(() => requestAnimationFrame(sync));
  }

  _handleSizeMemoryApplied() {
    this._runSizeSync();
  }

  _handleDomContentLoaded() {
    this._runSizeSync();
  }

  _getTierIndex(item) {
    if (!item) return null;
    const items = Array.from(this.querySelectorAll(ITEM_SELECTOR));
    const index = items.indexOf(item);
    return index === -1 ? null : index + 1;
  }

  _getSelectedTier() {
    return this.querySelector(SELECTED_ITEM_SELECTOR);
  }

  _getSelectedTierIndex() {
    return this._getTierIndex(this._getSelectedTier());
  }

  _getProductHandle() {
    return (
      document.querySelector(".product-form input[name='id']")?.dataset
        .handle ||
      document.querySelector('.product-default[data-handle]')?.dataset.handle ||
      ''
    );
  }

  _slugify(text) {
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  _isFirstCardInTier(card) {
    const item = card?.closest(ITEM_SELECTOR);
    const firstCard = item?.querySelector(
      `${PRODUCT_CARD_SELECTOR}:first-of-type`
    );
    return Boolean(card && firstCard && card === firstCard);
  }

  _getCardTitle(card) {
    const titleEl = card?.querySelector('.picky-product-card__title');
    return (
      titleEl?.getAttribute('aria-label') || titleEl?.textContent?.trim() || ''
    );
  }

  async _searchProductHandle(productId, query) {
    if (!query) return '';

    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`
      );
      if (!response.ok) return '';

      const data = await response.json();
      const products = data?.resources?.results?.products || [];
      const match = products.find(
        product => String(product.id) === String(productId)
      );
      return match?.handle || '';
    } catch {
      return '';
    }
  }

  async _fetchHandleBySlug(slug, productId) {
    if (!slug) return '';

    try {
      const response = await fetch(`/products/${slug}.json`);
      if (!response.ok) return '';

      const data = await response.json();
      if (String(data?.product?.id) !== String(productId)) return '';

      return data.product.handle || '';
    } catch {
      return '';
    }
  }

  async _fetchProductHandleById(productId, title) {
    return (
      (await this._searchProductHandle(productId, title)) ||
      (await this._searchProductHandle(productId, productId)) ||
      (await this._fetchHandleBySlug(this._slugify(title), productId))
    );
  }

  async _resolveCardHandles() {
    const cards = Array.from(
      this.querySelectorAll(`${PRODUCT_CARD_SELECTOR}[data-product-id]`)
    ).filter(
      card =>
        !this._isFirstCardInTier(card) &&
        !card.getAttribute('data-product-handle')
    );

    if (!cards.length) return;

    const byProductId = new Map();
    cards.forEach(card => {
      const productId = card.dataset.productId;
      if (!productId) return;
      if (!byProductId.has(productId)) byProductId.set(productId, []);
      byProductId.get(productId).push(card);
    });

    for (const [productId, productCards] of byProductId) {
      const title = this._getCardTitle(productCards[0]);
      const handle = await this._fetchProductHandleById(productId, title);
      if (!handle) continue;

      productCards.forEach(card => {
        card.setAttribute('data-product-handle', handle);
      });
    }
  }

  _getCardHandle(card) {
    return card?.getAttribute('data-product-handle') || '';
  }

  _getCardVariantId(card) {
    return card?.getAttribute('data-selected-variant-id') || '';
  }

  _getOptionChangeOverrides(card, variantId = '') {
    const overrides = {};
    if (!card) return overrides;

    if (this._isFirstCardInTier(card)) {
      overrides.content_url = this._getProductHandle();
    } else {
      const cardHandle = this._getCardHandle(card);
      if (cardHandle) overrides.content_url = cardHandle;
    }

    const resolvedVariantId = variantId || this._getCardVariantId(card);
    if (resolvedVariantId) overrides.item_id = resolvedVariantId;

    return overrides;
  }

  _readBundleEventExtras() {
    return typeof readPdpEventExtras === 'function' ? readPdpEventExtras() : {};
  }

  _pushBundleEvent(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'custom_event',
      event_name: eventName,
      parameter: JSON.stringify(params)
    });
  }

  _pushOptionChange(eventName, from, value, tier, overrides = {}) {
    const { item_id: _pdpItemId, ...extras } = this._readBundleEventExtras();
    const payload = {
      from: from || '',
      value: value || '',
      content_url: overrides.content_url || this._getProductHandle(),
      type: 'product',
      tier,
      ...extras
    };

    if (overrides.item_id) {
      const variantId = Number(overrides.item_id);
      if (!Number.isNaN(variantId)) payload.item_id = variantId;
    }

    this._pushBundleEvent(eventName, payload);
  }

  _getOptionLabel(select, value) {
    if (!select) return '';
    const option = Array.from(select.options).find(opt => opt.value === value);
    return option?.textContent?.trim() || value || '';
  }

  _trackSelectPrevious(select) {
    if (!select) return;
    this._prevOptionBySelect.set(select, select.value);
  }

  _handleTierPointerDown(event) {
    if (!event.isTrusted) return;

    const item = event.target.closest(ITEM_SELECTOR);
    if (!item || !this.contains(item)) return;
    if (event.target.closest(BUNDLE_CONTENT_SELECTOR)) return;
    if (event.target.closest('.amplify-bundle-breaks-widget__dropdown-list')) {
      return;
    }
    if (event.target.closest('.picky-option')) return;

    if (this._isTierSelected(item)) {
      this._pendingTierItem = null;
      return;
    }

    this._pendingTierItem = item;
  }

  _syncSelectedTierAnalytics() {
    if (!this._pendingTierItem) return;
    if (!this._isAnalyticsActive()) return;

    const candidate = this._pendingTierItem;
    if (!this._isTierSelected(candidate)) return;

    this._pendingTierItem = null;
    const tier = this._getTierIndex(candidate);
    if (tier == null) return;

    this._pushBundleEvent('bundle_block_click', { tier });
  }

  _handleAtcAnalytics(event) {
    if (!event.isTrusted) return;
    if (!this._isAnalyticsActive()) return;

    const button = event.target.closest(
      `${ATC_BUTTON_SELECTOR}, ${STICKY_ATC_BUTTON_SELECTOR}`
    );
    if (!button) return;
    if (!this._isMainProductAtc(button)) return;
    if (this._isSelectedBundleAddonUnavailable()) return;

    const tier = this._getSelectedTierIndex();
    if (!tier) return;

    const pushAtc =
      typeof pushAmplifyBundleAddToCart === 'function'
        ? pushAmplifyBundleAddToCart
        : null;
    if (!pushAtc) return;

    const waitForLoad =
      typeof waitForProductPageLoad === 'function'
        ? waitForProductPageLoad
        : () => Promise.resolve();

    waitForLoad().then(() => {
      window.setTimeout(() => {
        pushAtc(tier);
        if (
          document.body.classList.contains('tw-b2b') &&
          typeof addToCartQuantityB2BEvent === 'function'
        ) {
          addToCartQuantityB2BEvent();
        }
      }, 50);
    });
  }

  _handleWidgetOptionChange(event) {
    if (!this._isAnalyticsActive()) return;
    if (this._isSyncingSize || this._isProgrammaticSelectChange) return;

    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;
    if (!this.contains(select)) return;

    const optionEl = select.closest('.picky-option');
    if (!optionEl) return;

    const optionName = optionEl.dataset.optionName;
    if (optionName !== 'Color' && optionName !== 'Size') return;

    const tierItem = select.closest(ITEM_SELECTOR);
    const tier = this._getTierIndex(tierItem);
    if (!tier) return;

    const prevValue = this._prevOptionBySelect.get(select) ?? '';
    const nextValue = select.value;
    if (!nextValue || prevValue === nextValue) return;

    const fromLabel = this._getOptionLabel(select, prevValue);
    const toLabel = this._getOptionLabel(select, nextValue);
    const card = select.closest(PRODUCT_CARD_SELECTOR);
    if (!card) return;

    const emitOptionChange = () => {
      const variantId =
        optionName === 'Color' && /^\d+$/.test(nextValue)
          ? nextValue
          : this._getCardVariantId(card);

      this._pushOptionChange(
        optionName === 'Color'
          ? 'bundle_block_color_change'
          : 'bundle_block_size_change',
        fromLabel || prevValue,
        toLabel || nextValue,
        tier,
        this._getOptionChangeOverrides(card, variantId)
      );
      this._trackSelectPrevious(select);
    };

    if (optionName === 'Size') {
      requestAnimationFrame(() => requestAnimationFrame(emitOptionChange));
      return;
    }

    emitOptionChange();
  }

  _handlePdpColorClick(event) {
    if (!this._isAnalyticsActive()) return;

    const targetColor = event.target.closest(PDP_COLOR_SWATCH_SELECTOR);
    if (!targetColor) return;

    const tier = this._getSelectedTierIndex();
    if (!tier) return;

    const activeColorSpan = document.querySelector(
      '.product__info-wrapper div.color_swatch_item-span.color_active'
    );
    const fromValue = document.body.dataset.template?.includes('supplement-new')
      ? activeColorSpan?.dataset.colorName
      : activeColorSpan?.parentElement?.dataset.colorName;
    const toValue = targetColor.dataset.colorName;
    if (!toValue || fromValue === toValue) return;

    const tierEl = this._getSelectedTier();
    const firstCard = tierEl?.querySelector(
      `${PRODUCT_CARD_SELECTOR}:first-of-type`
    );

    requestAnimationFrame(() => {
      this._pushOptionChange(
        'bundle_block_color_change',
        fromValue || '',
        toValue,
        tier,
        this._getOptionChangeOverrides(firstCard)
      );
    });
  }

  _handlePdpSizePointerDown(event) {
    if (!this._isAnalyticsActive()) return;

    const sizeBtn = event.target.closest(
      'variant-radios .size_option_input .size_slider .item'
    );
    if (!sizeBtn) return;

    const activeSize = document.querySelector(
      `${PDP_SIZE_INPUT_SELECTOR}:checked`
    );
    this._pdpPreviousSize = activeSize ? activeSize.value : null;
  }

  _handlePdpSizeChange(event) {
    if (!this._isAnalyticsActive()) return;
    if (this._isSyncingSize) return;
    if (!(event.target instanceof HTMLInputElement)) return;
    if (!event.target.matches(PDP_SIZE_INPUT_SELECTOR)) return;

    const tier = this._getSelectedTierIndex();
    if (!tier) return;

    const newValue = event.target.value;
    const previousSize = this._pdpPreviousSize;
    if (!previousSize || !newValue || newValue === previousSize) return;

    const tierEl = this._getSelectedTier();
    const firstCard = tierEl?.querySelector(
      `${PRODUCT_CARD_SELECTOR}:first-of-type`
    );

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this._pushOptionChange(
          'bundle_block_size_change',
          previousSize,
          newValue,
          tier,
          this._getOptionChangeOverrides(firstCard)
        );
        this._pdpPreviousSize = newValue;
      });
    });
  }

  _initOptionTracking() {
    this.querySelectorAll(`${PRODUCT_OPTION_SELECTOR} select`).forEach(select =>
      this._trackSelectPrevious(select)
    );
  }

  _enhance() {
    this._runSync();
  }

  _handleWidgetMutations(mutations) {
    // Amplify's own bundle-breaks widget rewrites tier class attributes on every
    // render tick even when nothing actually changes; reacting to those no-op
    // writes retriggers _runSync() in lockstep and blinks the sticky subheader
    const hasRealChange = mutations.some(
      mutation =>
        mutation.type !== 'attributes' ||
        mutation.oldValue !== mutation.target.getAttribute('class')
    );
    if (!hasRealChange) return;

    if (this._syncFrame) return;

    this._syncFrame = requestAnimationFrame(() => {
      this._syncFrame = null;
      this._runSync();
    });
  }

  _runSync() {
    if (this._syncing) return;
    this._syncing = true;

    this._observer?.disconnect();

    try {
      this._syncWidgetVisibility();
      this._syncInactiveOptions();
      this._bindDropdowns();
      this._updateBadges();
      this._syncUnavailableTiers();
      this._preselectFirstTier();
      this._syncBundlePricing();
      this._syncStickyVariantInfo();
      this._runSizeSync();
      this._initOptionTracking();
      this._syncSelectedTierAnalytics();
      this._resolveCardHandles();
    } finally {
      this._observer?.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true
      });
      this._syncing = false;
    }
  }

  _getEventElement(event) {
    const { target } = event;
    if (target instanceof Element) return target;
    return target?.parentElement ?? null;
  }

  _handleDocumentPointerDown(event) {
    if (!this.querySelector(`${DROPDOWN_SELECTOR}.${OPEN_CLASS}`)) return;

    const target = this._getEventElement(event);
    if (!target) return;

    const clickedInsideOpenDropdown = Array.from(
      this.querySelectorAll(`${DROPDOWN_SELECTOR}.${OPEN_CLASS}`)
    ).some(dropdown => dropdown.contains(target));

    if (clickedInsideOpenDropdown) return;

    this._closeAllDropdowns();
  }

  _handleFormChange(event) {
    if (!event.target.closest('form[data-type="add-to-cart-form"]')) return;
    this._syncWidgetVisibility();
    this._runSizeSync();
    VARIANT_SYNC_DELAYS.forEach(delay => {
      window.setTimeout(() => {
        this._syncWidgetVisibility();
        this._syncBundlePricing();
        this._syncSizeSliderToPicky();
        this._syncFirstCardAvailability();
        this._syncUnavailableTiers();
        this._syncAtcState();
      }, delay);
    });
  }

  _handleSizeSliderChange(event) {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (!event.target.matches(SIZE_SLIDER_INPUT_SELECTOR)) return;
    this._syncWidgetVisibility();
    this._runSizeSync();
    VARIANT_SYNC_DELAYS.forEach(delay => {
      window.setTimeout(() => {
        this._syncWidgetVisibility();
        this._syncFirstCardAvailability();
        this._syncUnavailableTiers();
        this._syncAtcState();
      }, delay);
    });
  }

  _handleAtcClickCapture(event) {
    if (!this._isPrimaryWidget()) return;

    const button = event.target.closest(
      `${ATC_BUTTON_SELECTOR}, ${STICKY_ATC_BUTTON_SELECTOR}`
    );
    if (!button) return;
    if (!this._isMainProductAtc(button)) return;

    if (AmplifyBundleBreaksWidget._shouldUseStandardPdpAtc()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this._addSoloItemToCart(button);
      return;
    }

    if (!this._isWidgetActive()) return;

    if (this._isSelectedBundleAddonUnavailable()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this._scrollToWidget();
      return;
    }

    if (this._isSoloTierSelected()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this._addSoloItemToCart(button);
    }
  }

  _handleFormSubmitCapture(event) {
    if (!this._isPrimaryWidget()) return;
    if (!AmplifyBundleBreaksWidget._shouldUseStandardPdpAtc()) return;

    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.type !== 'add-to-cart-form') return;
    if (form !== this._getMainProductForm()) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const button = form.querySelector('[type="submit"][name="add"]');
    if (button) this._addSoloItemToCart(button);
  }

  _scrollToWidget() {
    this.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  _getMainProductForm() {
    return (
      this.closest(PRODUCT_INFO_CONTAINER_SELECTOR)?.querySelector(
        PRODUCT_FORM_SELECTOR
      ) ?? document.querySelector(PRODUCT_FORM_SELECTOR)
    );
  }

  _isMainProductAtc(button) {
    if (button.matches(STICKY_ATC_BUTTON_SELECTOR)) return true;

    const mainForm = this._getMainProductForm();
    return (
      Boolean(mainForm) && button.closest(PRODUCT_FORM_SELECTOR) === mainForm
    );
  }

  _isSoloTierSelected() {
    if (this._isSelectedVariantUnavailable()) return false;

    const tier = this.querySelector(SELECTED_ITEM_SELECTOR);
    if (!tier) return false;

    return tier.querySelectorAll(PRODUCT_CARD_SELECTOR).length === 1;
  }

  async _addSoloItemToCart(button) {
    if (this._soloAddInFlight) {
      AmplifyBundleBreaksWidget._endBundleAdd();
      return;
    }

    const form = this._getMainProductForm();
    const id = Number(form?.querySelector('input[name="id"]')?.value);
    if (!id) {
      AmplifyBundleBreaksWidget._endBundleAdd();
      return;
    }

    const quantity =
      Number(form.querySelector('input[name="quantity"]')?.value) || 1;

    this._soloAddInFlight = true;
    this._toggleSoloLoading(button, true);

    try {
      const added = await window.addToCart([{ id, quantity }], 'product_page');
      if (!added) {
        AmplifyBundleBreaksWidget._endBundleAdd();
        return;
      }

      const waitForLoad =
        typeof waitForProductPageLoad === 'function'
          ? waitForProductPageLoad
          : () => Promise.resolve();

      const atcSuffix = button.matches(STICKY_ATC_BUTTON_SELECTOR)
        ? 'quick_add'
        : 'main';

      waitForLoad().then(() => {
        window.setTimeout(() => {
          if (typeof handleAddToCartEvent === 'function') {
            handleAddToCartEvent(atcSuffix);
          }
        }, 50);
      });

      await window.fetchCart(added.sections?.['slide-cart-fragment']);
      document.dispatchEvent(
        new CustomEvent('cart:added', {
          detail: { source: 'amplify-bundle-solo' }
        })
      );
    } finally {
      this._toggleSoloLoading(button, false);
      this._soloAddInFlight = false;
    }
  }

  _toggleSoloLoading(button, isLoading) {
    button.classList.toggle('loading', isLoading);
    button
      .querySelector('.loading-overlay__spinner')
      ?.classList.toggle('hidden', !isLoading);
  }

  _isSelectedBundleAddonUnavailable() {
    if (this._isSelectedVariantUnavailable()) return false;

    const tier = this.querySelector(SELECTED_ITEM_SELECTOR);
    const bundle = tier?.querySelector(BUNDLE_CONTENT_SELECTOR);
    if (!bundle) return false;

    const firstCard = tier.querySelector(
      `${PRODUCT_CARD_SELECTOR}:first-of-type`
    );

    return Array.from(bundle.querySelectorAll(PRODUCT_CARD_SELECTOR)).some(
      card => {
        if (card === firstCard) return false;
        return this._isProductCardUnavailable(card);
      }
    );
  }

  _isProductCardUnavailable(card) {
    const hasUnavailableClass = Array.from(card.classList).some(className =>
      PRODUCT_CARD_UNAVAILABLE_CLASS_PATTERN.test(className)
    );
    if (hasUnavailableClass) return true;

    const outOfStock = card.querySelector(OUT_OF_STOCK_SELECTOR);
    if (!outOfStock) return false;

    const wrapper = outOfStock.closest('[class*="_root_"]') ?? outOfStock;
    return !wrapper.hidden;
  }

  _syncAtcState() {
    if (!this._isWidgetActive()) return;

    const blocked = this._isSelectedBundleAddonUnavailable();
    const buttons = [
      ...document.querySelectorAll(ATC_BUTTON_SELECTOR),
      ...document.querySelectorAll(STICKY_ATC_BUTTON_SELECTOR)
    ];
    buttons.forEach(button =>
      button.classList.toggle(ATC_BLOCKED_CLASS, blocked)
    );

    if (blocked) this._enforceClickableAtc();
  }

  _bindAtcButtonGuard() {
    const buttons = document.querySelectorAll(ATC_BUTTON_SELECTOR);
    if (!buttons.length) return;

    this._atcButtonObserver = new MutationObserver(() =>
      this._enforceClickableAtc()
    );
    buttons.forEach(button =>
      this._atcButtonObserver.observe(button, {
        attributes: true,
        attributeFilter: ['disabled']
      })
    );
  }

  _enforceClickableAtc() {
    if (!this._isSelectedBundleAddonUnavailable()) return;

    document.querySelectorAll(ATC_BUTTON_SELECTOR).forEach(button => {
      if (button.hasAttribute('disabled')) button.removeAttribute('disabled');
    });
  }

  _isSelectedVariantUnavailable() {
    const notifyButton = document.querySelector(NOTIFY_BUTTON_SELECTOR);
    if (notifyButton) return !notifyButton.hasAttribute('disabled');

    const input = document.querySelector(SELECTED_VARIANT_INPUT_SELECTOR);
    if (input instanceof HTMLInputElement) {
      return input.dataset.available !== 'true';
    }

    return false;
  }

  _syncWidgetVisibility() {
    this.classList.toggle(
      WIDGET_VARIANT_OOS_CLASS,
      this._isSelectedVariantUnavailable()
    );
  }

  _syncInactiveOptions() {
    this.querySelectorAll(PRODUCT_OPTION_SELECTOR).forEach(option => {
      const select = option.querySelector('select');
      const enabledOptions = select
        ? Array.from(select.options).filter(opt => !opt.disabled)
        : [];
      const shouldHide =
        !select ||
        select.disabled ||
        enabledOptions.length <= 1 ||
        /_option_hidden_/.test(option.className);

      option.classList.toggle(INACTIVE_OPTION_CLASS, shouldHide);
    });
  }

  _getCheckedSizeSliderVariant() {
    const input = document.querySelector(
      `${SIZE_SLIDER_INPUT_SELECTOR}:checked`
    );
    if (!(input instanceof HTMLInputElement)) return null;

    const variantId = input.dataset.variantId;
    if (!variantId) return null;

    return {
      id: variantId,
      available: input.dataset.available === 'true'
    };
  }

  _setProductCardAvailability(card, isAvailable, variantId) {
    if (!card) return;

    if (variantId) card.dataset.selectedVariantId = variantId;

    if (isAvailable) {
      Array.from(card.classList).forEach(className => {
        if (PRODUCT_CARD_UNAVAILABLE_CLASS_PATTERN.test(className)) {
          card.classList.remove(className);
        }
      });
    }

    const outOfStockRoot = card.querySelector('[class*="_outOfStock_"]');
    const outOfStockWrapper =
      outOfStockRoot?.closest('[class*="_root_"]') ?? outOfStockRoot;
    if (outOfStockWrapper) outOfStockWrapper.hidden = isAvailable;
  }

  _syncFirstCardAvailability() {
    const variant = this._getCheckedSizeSliderVariant();
    if (!variant) return;

    this.querySelectorAll(FIRST_CARD_SELECTOR).forEach(card => {
      this._setProductCardAvailability(card, variant.available, variant.id);
    });
  }

  _isFirstCardFullyOutOfStock() {
    const inputs = document.querySelectorAll(SIZE_SLIDER_INPUT_SELECTOR);
    if (inputs.length) {
      return Array.from(inputs).every(
        input => input.dataset.available !== 'true'
      );
    }

    const variant = this._getCheckedSizeSliderVariant();
    return variant ? !variant.available : false;
  }

  _isProductFullyOutOfStock(card) {
    if (!card) return false;

    const selects = Array.from(
      card.querySelectorAll(`${PRODUCT_OPTION_SELECTOR} select`)
    ).filter(select => {
      const option = select.closest('.picky-option');
      if (!option) return false;
      if (option.classList.contains(INACTIVE_OPTION_CLASS)) return false;
      if (/_option_hidden_/.test(option.className)) return false;
      return true;
    });

    if (!selects.length) return false;

    return selects.every(select =>
      Array.from(select.options).every(option => option.disabled)
    );
  }

  _isTierUnavailable(item) {
    const bundle = item.querySelector(BUNDLE_CONTENT_SELECTOR);
    if (!bundle) return false;

    return Array.from(bundle.querySelectorAll(PRODUCT_CARD_SELECTOR)).some(
      card => {
        const isFirstCard =
          card === item.querySelector(`${PRODUCT_CARD_SELECTOR}:first-of-type`);

        return isFirstCard
          ? this._isFirstCardFullyOutOfStock()
          : this._isProductFullyOutOfStock(card);
      }
    );
  }

  _isTierSelected(item) {
    return Array.from(item.classList).some(className =>
      TIER_SELECTED_CLASS_PATTERN.test(className)
    );
  }

  _selectTier(item) {
    if (!item || this._isTierSelected(item)) return;

    const focusTarget =
      item.querySelector('[class*="_focus_"]') ??
      item.querySelector('[tabindex]') ??
      item;
    focusTarget.click();
  }

  _preselectFirstTier() {
    if (this.querySelector(SELECTED_ITEM_SELECTOR)) return;

    const firstTier = Array.from(this.querySelectorAll(ITEM_SELECTOR)).find(
      item =>
        !item.hasAttribute('hidden') &&
        !item.classList.contains(TIER_UNAVAILABLE_CLASS)
    );

    if (firstTier) this._selectTier(firstTier);
  }

  _bindVariationObserver() {
    if (this._variationObserver || !this._isPrimaryWidget()) return;

    this._variationObserver = new MutationObserver(() => {
      if (!this._isPrimaryWidget()) return;
      this._runSync();
    });
    this._variationObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  _syncUnavailableTiers() {
    // Every tier holds the main product, so a fully OOS variant makes whichever tier
    // is expanded read as unavailable: hiding it reselects another tier, which then
    // reads as unavailable in turn and loops forever
    if (this._isSelectedVariantUnavailable()) return;

    const items = Array.from(this.querySelectorAll(ITEM_SELECTOR));

    if (!items.length) {
      this.classList.remove(WIDGET_EMPTY_CLASS);
      return;
    }

    let selectedTierHidden = false;

    items.forEach(item => {
      const unavailable = this._isTierUnavailable(item);
      item.classList.toggle(TIER_UNAVAILABLE_CLASS, unavailable);
      item.toggleAttribute('hidden', unavailable);

      if (unavailable && this._isTierSelected(item)) {
        selectedTierHidden = true;
      }
    });

    if (selectedTierHidden) {
      const nextTier = items.find(item => !item.hasAttribute('hidden'));
      if (nextTier) {
        this._selectTier(nextTier);
        VARIANT_SYNC_DELAYS.forEach(delay => {
          window.setTimeout(() => {
            this._syncBundlePricing();
            this._syncStickyVariantInfo();
          }, delay);
        });
      }
    }

    const hasVisibleTier = items.some(item => !item.hasAttribute('hidden'));
    this.classList.toggle(WIDGET_EMPTY_CLASS, !hasVisibleTier);
  }

  _getCheckedSizeSliderValue() {
    return (
      document.querySelector(`${SIZE_SLIDER_INPUT_SELECTOR}:checked`)?.value ??
      ''
    );
  }

  _isFirstCardSizeSelect(select) {
    const card = select?.closest('.picky-product-card');
    const item = card?.closest(ITEM_SELECTOR);
    if (!card || !item) return false;
    return item.querySelector('.picky-product-card:first-of-type') === card;
  }

  _setPickySelectValue(select, value) {
    if (!select || !value || select.value === value) return false;

    const option = Array.from(select.options).find(
      opt => opt.value === value && !opt.disabled
    );
    if (!option) return false;

    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    select.dispatchEvent(new Event('input', { bubbles: true }));

    const dropdown = select.closest(DROPDOWN_SELECTOR);
    if (dropdown?.hasAttribute(ENHANCED_ATTR)) {
      this._syncHeadTitle(dropdown, select);
      const list = dropdown.querySelector(
        '.amplify-bundle-breaks-widget__dropdown-list'
      );
      if (list) this._buildList(dropdown, select, list);
    }

    return true;
  }

  _syncSizeSliderToPicky() {
    if (this._isSyncingSize) return;

    const sizeValue = this._getCheckedSizeSliderValue();
    if (!sizeValue) return;

    this._isSyncingSize = true;
    this.querySelectorAll(FIRST_CARD_SIZE_SELECT_SELECTOR).forEach(select => {
      this._setPickySelectValue(select, sizeValue);
    });
    this._isSyncingSize = false;
    this._syncFirstCardAvailability();
    this._syncUnavailableTiers();
  }

  _syncPickyToSizeSlider(select) {
    if (this._isSyncingSize || !this._isFirstCardSizeSelect(select)) return;

    const sizeValue = select.value;
    if (!sizeValue) return;

    const sliderInput = document.querySelector(
      `${SIZE_SLIDER_INPUT_SELECTOR}[value="${CSS.escape(sizeValue)}"]`
    );
    if (!sliderInput || sliderInput.checked) return;

    this._isSyncingSize = true;
    setRadioChecked(sliderInput, true);
    sliderInput.dispatchEvent(new Event('change', { bubbles: true }));
    this._isSyncingSize = false;
  }

  _updateBadge(item) {
    const badge = item.querySelector(BADGE_SELECTOR);
    const finalEl = item.querySelector(PRICE_SELECTOR);
    const compareEl = item.querySelector(COMPARE_SELECTOR);
    if (!badge || !finalEl || !compareEl) return;

    const finalPrice = parsePrice(finalEl.textContent);
    const comparePrice = parsePrice(compareEl.textContent);
    if (
      !Number.isFinite(finalPrice) ||
      !Number.isFinite(comparePrice) ||
      comparePrice <= 0 ||
      finalPrice >= comparePrice
    ) {
      return;
    }

    const percent = Math.round((1 - finalPrice / comparePrice) * 100);
    const label = (badge.textContent || '')
      .replace(/[\d.,].*$/, '')
      .replace(/[^\p{L}]+$/u, '')
      .trim();
    const nextText = `${label} ${percent}%`.trim();

    if (badge.textContent !== nextText) badge.textContent = nextText;
  }

  _updateBadges() {
    this.querySelectorAll(ITEM_SELECTOR).forEach(item =>
      this._updateBadge(item)
    );
  }

  _getPdpComparePrice() {
    const el =
      document.querySelector(
        '.product_slider_mob .price__compare .price-item'
      ) ||
      document.querySelector(
        '.product__info-container .selling .price__compare .price-item'
      ) ||
      document.querySelector(
        '.product__info-container .price__compare .price-item'
      );
    return el?.textContent?.trim() || '';
  }

  _getSelectedBundle() {
    const tier = this.querySelector(SELECTED_ITEM_SELECTOR);
    if (!tier) return null;

    const final = tier.querySelector(PRICE_SELECTOR)?.textContent.trim() || '';
    if (!final) return null;

    let compare =
      tier.querySelector(COMPARE_SELECTOR)?.textContent.trim() || '';

    if (!compare) {
      const firstTier = this.querySelector(ITEM_SELECTOR);
      if (tier === firstTier) {
        compare = this._getPdpComparePrice();
      }
    }

    return {
      final,
      compare,
      name: tier.querySelector(TIER_NAME_SELECTOR)?.textContent.trim() || ''
    };
  }

  _shouldShowStickyBundlePrice() {
    return !isMobileViewport() || this._bundleBlockSeen;
  }

  _updateStickyPriceVisibility() {
    document
      .querySelector(STICKY_BAR_SELECTOR)
      ?.classList.toggle(
        STICKY_PRICE_HIDDEN_CLASS,
        isMobileViewport() && !this._bundleBlockSeen
      );
  }

  _bindBundleVisibility() {
    if (this._visibilityObserver) return;

    this._visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return;

        this._bundleBlockSeen = true;
        this._visibilityObserver?.disconnect();
        this._visibilityObserver = null;
        this._updateStickyPriceVisibility();
        this._syncBundlePricing();
      },
      { threshold: 0.01 }
    );

    this._visibilityObserver.observe(this);
    this._updateStickyPriceVisibility();
  }

  _handleResize() {
    this._updateStickyPriceVisibility();
    if (this._shouldShowStickyBundlePrice()) this._syncBundlePricing();
  }

  _syncStickyVariantInfo() {
    if (this._isSelectedVariantUnavailable()) {
      document
        .querySelectorAll(STICKY_VARIANT_INFO_SELECTOR)
        .forEach(el => el.classList.remove('tw-hidden'));
      return;
    }

    const selectedTier = this.querySelector(SELECTED_ITEM_SELECTOR);
    const firstTier = this.querySelector(ITEM_SELECTOR);
    if (!selectedTier || !firstTier) return;

    const isSoloTier = selectedTier === firstTier;
    document.querySelectorAll(STICKY_VARIANT_INFO_SELECTOR).forEach(el => {
      el.classList.toggle('tw-hidden', !isSoloTier);
    });
  }

  _syncBundlePricing() {
    if (!this._isWidgetActive()) return;
    if (this._isSelectedVariantUnavailable()) return;

    const bundle = this._getSelectedBundle();
    if (!bundle) return;

    this._updateStickyPriceVisibility();
    if (!this._shouldShowStickyBundlePrice()) return;

    applyPriceBlock(
      document.querySelector(STICKY_PRICE_SELECTOR),
      bundle.final,
      bundle.compare
    );
    applyStickyButton(bundle.final, bundle.compare);

    const titleEl = document.querySelector(STICKY_TITLE_SELECTOR);
    if (titleEl && bundle.name && titleEl.textContent.trim() !== bundle.name) {
      titleEl.textContent = bundle.name;
    }
  }

  _syncItemStacking(dropdown) {
    const bundleItem = dropdown.closest('.picky-bundle-breaks__item');
    if (!bundleItem) return;

    bundleItem.classList.toggle(
      ITEM_OPEN_CLASS,
      Boolean(bundleItem.querySelector(`${DROPDOWN_SELECTOR}.${OPEN_CLASS}`))
    );
  }

  _closeDropdown(dropdown) {
    dropdown.classList.remove(OPEN_CLASS);
    dropdown
      .querySelector('[class*="_head_"]')
      ?.setAttribute('aria-expanded', 'false');
    this._syncItemStacking(dropdown);
  }

  _closeAllDropdowns() {
    this.querySelectorAll(`${DROPDOWN_SELECTOR}.${OPEN_CLASS}`).forEach(
      dropdown => this._closeDropdown(dropdown)
    );
  }

  _syncHeadTitle(dropdown, select) {
    const title = dropdown.querySelector(
      '[class*="_head_"] [class*="_title_"]'
    );
    if (!title || !select) return;

    const selectedOption = select.options[select.selectedIndex];
    const label = selectedOption?.textContent?.trim() ?? '';

    title.textContent = label;
    title.classList.toggle(
      'amplify-bundle-breaks-widget__dropdown-title--unavailable',
      Boolean(selectedOption?.disabled)
    );
  }

  _buildList(dropdown, select, list) {
    list.replaceChildren();

    Array.from(select.options).forEach(option => {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'amplify-bundle-breaks-widget__dropdown-item';
      item.textContent = option.textContent?.trim() ?? '';
      item.disabled = option.disabled;

      if (option.selected) {
        item.classList.add(
          'amplify-bundle-breaks-widget__dropdown-item--selected'
        );
        item.setAttribute('aria-selected', 'true');
      }

      item.addEventListener('click', () => {
        if (option.disabled) return;

        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        select.dispatchEvent(new Event('input', { bubbles: true }));

        this._syncHeadTitle(dropdown, select);
        this._buildList(dropdown, select, list);
        this._closeDropdown(dropdown);
      });

      list.appendChild(item);
    });
  }

  _bindDropdown(dropdown) {
    if (dropdown.hasAttribute(ENHANCED_ATTR)) return;

    const select = dropdown.querySelector('select');
    const head = dropdown.querySelector('[class*="_head_"]');
    if (!select || !head) return;

    dropdown.setAttribute(ENHANCED_ATTR, 'true');
    select.classList.add('amplify-bundle-breaks-widget__native-select');
    select.tabIndex = -1;

    const list = document.createElement('div');
    list.className = 'amplify-bundle-breaks-widget__dropdown-list';
    list.setAttribute('role', 'listbox');
    dropdown.appendChild(list);

    head.setAttribute('role', 'button');
    head.setAttribute('aria-expanded', 'false');
    head.setAttribute('tabindex', '0');

    const stopTierPointer = event => event.stopPropagation();
    dropdown.addEventListener('mousedown', stopTierPointer, true);
    dropdown.addEventListener('pointerdown', stopTierPointer, true);

    const openDropdown = () => {
      this._buildList(dropdown, select, list);
      dropdown.classList.add(OPEN_CLASS);
      head.setAttribute('aria-expanded', 'true');
      this._syncItemStacking(dropdown);
    };

    const toggle = () => {
      const enabledOptions = Array.from(select.options).filter(
        opt => !opt.disabled
      );
      if (select.disabled && enabledOptions.length <= 1) return;

      if (dropdown.classList.contains(OPEN_CLASS)) {
        this._closeDropdown(dropdown);
        return;
      }

      this._closeAllDropdowns();
      openDropdown();
    };

    head.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      toggle();
    });

    head.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
      if (event.key === 'Escape') this._closeDropdown(dropdown);
    });

    select.addEventListener('change', () => {
      this._syncHeadTitle(dropdown, select);
      this._buildList(dropdown, select, list);
      this._syncPickyToSizeSlider(select);
      if (this._isFirstCardSizeSelect(select)) {
        VARIANT_SYNC_DELAYS.forEach(delay => {
          window.setTimeout(() => {
            this._syncFirstCardAvailability();
            this._syncUnavailableTiers();
          }, delay);
        });
      } else {
        this._syncUnavailableTiers();
        VARIANT_SYNC_DELAYS.forEach(delay => {
          window.setTimeout(() => this._syncUnavailableTiers(), delay);
        });
      }
    });

    new MutationObserver(() => {
      this._syncHeadTitle(dropdown, select);
      this._buildList(dropdown, select, list);
      if (this._isFirstCardSizeSelect(select)) {
        this._runSizeSync();
      }
    }).observe(select, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['selected', 'disabled']
    });

    this._syncHeadTitle(dropdown, select);
    this._buildList(dropdown, select, list);
  }

  _bindDropdowns() {
    this.querySelectorAll(
      `${DROPDOWN_SELECTOR}:not([${ENHANCED_ATTR}])`
    ).forEach(dropdown => {
      if (dropdown.closest(`.${INACTIVE_OPTION_CLASS}`)) return;
      this._bindDropdown(dropdown);
    });
  }
}

if (!customElements.get('amplify-bundle-breaks-widget')) {
  customElements.define(
    'amplify-bundle-breaks-widget',
    AmplifyBundleBreaksWidget
  );
}

window.amplifyBundleBreaksUsesStandardAtc = () =>
  AmplifyBundleBreaksWidget._shouldUseStandardPdpAtc();
